// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"1180dc5690ba80a157e9","453":"1593b092957dbd2f4827","471":"cc3ef78c9415c2089019"}[chunkId] + ".js";
};